<template>
  <v-slide-y-transition mode="out-in">
    <div id="coa-forms" style="margin-top: -20px">
      <v-container grid-list-xl fluid>                
        <v-card pa-0> 
          <v-toolbar dark flat dense cad color="primary">
            <v-toolbar-title class="subheading">Form User</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="form-btn">
                <v-btn v-if="!isUpdate" @click="save(isUpdate)" v-bind:loading="loading" outline>Create</v-btn>
                <v-btn v-else @click="save(isUpdate)"  v-bind:loading="loading" outline>Update</v-btn>                                                                                        
            </div>
          </v-toolbar>
          <v-card-text class="">
            <v-layout row wrap>
              <v-flex lg4 sm6>  
                <v-form v-model="valid"> 
                  <v-select
                    box
                    v-bind:items="roles"
                    v-model="formModel.role"
                    label="Role"                        
                    v-validate="'required'"
                    data-vv-name="role"  
                    :error-messages="errors.collect('role')"  
                    required
                  ></v-select>
                  
                  <v-text-field box
                      label="Username"
                      name="username"                              
                      v-model="formModel.username"
                      v-validate="'required'"
                      data-vv-name="username"  
                      @keyup="setEmail()"
                      :error-messages="errors.collect('username')"  
                      required
                  ></v-text-field>

                  <v-text-field box
                    v-validate="'required|email'"
                    v-model="formModel.email"
                    :error-messages="errors.collect('email')"
                    label="E-mail"
                    data-vv-name="email"
                    required
                  ></v-text-field>  

                  <v-text-field          
                    box                    
                    v-model="formModel.password"
                    :error-messages="errors.collect('password')"
                    label="Password"
                    data-vv-name="password"
                    type="password"
                    required
                  ></v-text-field>  

                   <v-switch 
                    v-bind:label="formModel.status === 10 ? 'Status Active' : 'Status Inactive'" 
                    v-bind:true-value="10"
                    v-bind:false-value="0"                   
                    v-model="formModel.status">                      
                  </v-switch>


                  <v-text-field box
                      label="Fullname"
                      name="name"                              
                      v-model="formModel.fullname"
                      v-validate="'required'"
                      data-vv-name="name"     
                      :error-messages="errors.collect('name')"  
                      required
                  ></v-text-field>

                  <v-text-field box
                      label="Phone Number"
                      name="phone"                              
                      v-model="formModel.phone"
                      v-validate="'required'"
                      data-vv-name="phone"     
                      :error-messages="errors.collect('phone')"  
                      required
                  ></v-text-field>


                  <v-text-field
                    label="Address"
                    name="address"                              
                    v-model="formModel.address"
                    v-validate="'required'"
                    data-vv-name="address"     
                    box
                    :error-messages="errors.collect('address')"  
                    required
                  ></v-text-field>

                  <v-text-field
                    label="NIK"
                    name="nik"                              
                    v-model="formModel.nik"                       
                    box clearable                    
                  ></v-text-field>
                  
                  <v-textarea
                    label="Description"
                    name="description"                              
                    v-model="formModel.description"
                    box
                  ></v-textarea>
                                    
                </v-form>  
              </v-flex>    
              <v-flex lg8 sm6 xs12>
                <v-toolbar card prominent>
                  <v-autocomplete                                
                    :items="filterKompetisi"
                    :filter="customFilter"                                
                    item-text="name"
                    item-value="id"                     
                    label="Kompetisi ID"              
                    placeholder="Type to add kompetisi"
                    v-model="kompetisi_id"
                    flat solo hide-details clearable
                  ></v-autocomplete>                                            
                   
                </v-toolbar>
                <v-divider></v-divider>
                <v-alert v-if="alert" v-bind:value="alert.status" color="warning" icon="priority_high" dark>
                  {{alert.msg}}
                </v-alert>                                           
                <div class="v-table__overflow tabular pa-1" v-click-outside="notMagic">                                          
                  <v-data-table
                      :headers="headersDtl"
                      :items="formModel.userAreas"
                      :loading="loading"
                      hide-actions
                      class="elevation-1"       
                      v-bind:pagination.sync="pagination"
                  >                                
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>                             
                    <template slot="items" slot-scope="props" >
                      <td @click="isMagic(props)">{{props.index+1}}</td>
                      <td @click="isMagic(props)">
                        <span :style="'color:'+colorKompetisi(props.item.kompetisi_id)">
                          {{nameKompetisi(props.item.kompetisi_id)}}
                        </span>
                      </td>
                      <td @click="isMagic(props)">
                        <v-select
                          solo hide-details
                          v-bind:items="byrole(tingkats)"
                          v-model="props.item.tingkat"
                          label="Tingkat"    
                          item-text="name"
                          item-value="id"                        
                          v-bind:ref="'dtl'+props.index"
                          v-if="props.item.magic"                           
                          v-on:change="props.item.area_id = null; detail[getIndex(formModel.userAreas,props.item)].areas = []"
                        ></v-select>
                        <span class="results-as-you-type" v-else>
                          {{nameTingkat(props.item.tingkat)}} 
                        </span>                            
                      </td>
                      <td @click="isMagic(props)">
                        <v-autocomplete
                          solo hide-details
                          v-bind:items="detail[getIndex(formModel.userAreas,props.item)].areas"
                          v-bind:filter="customFilter"                      
                          v-bind:search-input.sync="detail[getIndex(formModel.userAreas,props.item)].areaSearch"
                          item-text="name"
                          item-value="id"
                          v-model="props.item.area_id"
                          label="Area ID"
                          hide-no-data clearable
                          v-bind:loading="detail[getIndex(formModel.userAreas,props.item)].areaLoading" 
                          v-if="props.item.magic"        
                          @change="setTabular(props.item.area_id, getIndex(formModel.userAreas,props.item))"
                        ></v-autocomplete>  
                        <span class="results-as-you-type"
                          v-else>{{ props.item.area }} 
                        </span>
                      </td>
                      <td class="text-xs-right">
                        <v-btn v-on:click="addDtl(props.item.kompetisi_id)" icon class="primary--text" small
                          v-bind:loading="detail[getIndex(formModel.userAreas,props.item)].areaLoading" >
                          <v-icon>add</v-icon>
                        </v-btn>
                      </td>
                      <td class="text-xs-right">                                                            
                        <v-btn v-on:click="delDtl(props)" icon class="pink--text" small
                          v-bind:loading="detail[getIndex(formModel.userAreas,props.item)].areaLoading" >
                          <v-icon>delete</v-icon>
                        </v-btn>                        
                      </td>                                
                    </template>
                  </v-data-table> 
                </div>  
              </v-flex>
            </v-layout>
          </v-card-text>       
        </v-card>
          
      </v-container>
    </div>
  </v-slide-y-transition>
</template>

<script>  
import Model  from '@/apps/frc/models/Saksi';    
import direct from '@/util/directives';

var model = new Model();

export default {
    directives : direct, 
    $_veeValidate: {
        validator: 'new'
    },    
    data: () => ({
        pagination : {'sortBy': 'kompetisi_id', 'descending': false, 'rowsPerPage': -1},
        panel:[],
        panelId:[],
        isUpdate:false,
        code: null,
        name:null,
        type: null, 
        swithStatus: false,
        formModel: {
          id      : null,  
          email    : null,          
          username : null,
          password : null,          
          name : null,
          phone : null,
          address : null, 
          nik : null,
          role : 'saksi',
          status : 10,                 
          userAreas : []
        },
        roles:[],
        tingkats:[],
        tingkatDef:5,
        detail:[],
        headersDtl:[
          {text:'No', value:'no'},
          {text:'Kompetisi', value:'kompetisi_id'},
          {text:'Tingkat', value:'tingkat'},
          {text:'Area ID', value:'area_id'},
          {text:'', value:'a'},
          {text:'', value:'an'},
        ], 
        statusSwitch :false,
        //countries: Countries,
        balance: [],    
        valid: true,
        loading : false,
        alert : null,
        kompetisis : [],
        kompetisi_id : null,
        idx : 0
    }),
    computed:{
      filterKompetisi(){
          let result = [];
          this.kompetisis.forEach((item)=>{
             let index = this.formModel.userAreas.findIndex(function(i){return i.kompetisi_id == item.id;});            
             if(index<0){
               result.push(item);
             }
          });   
          return result;
      },
    },
    watch:{      
      kompetisi_id(newVal){
        if(newVal){
          var ketemu = false;
          this.formModel.userAreas.forEach(item=>{
            if(item.kompetisi_id === newVal) ketemu = true;
          });
          if(!ketemu){
            this.newDtl({kompetisi_id : newVal, id:null, tingkat:this.tingkatDef, 
              area:null, areaName:null,
              area_id:null}, this.idx);                     
          }
          var ctx=this; setTimeout(function(){ctx.kompetisi_id = null;},500);
        }
      },
    },
    created () {this.setTingkats(); this.setKompetisi(); this.setRoles()
     
    },    
    mounted () {this.init();}, 
    methods : {
        init(){
            if(this.$route.query.id){
                this.isUpdate  = true; this.loading= true;
                model.one({id : this.$route.query.id }).then(data => {                      
                    Object.assign(this.formModel, data === null ? {}:data);
                    this.formModel.userArea.forEach((item,i)=>{this.newDtl(item, i);});
                    this.checking(data); this.loading=false;
                });                                               
            }            
            this.$validator.localize('en', this.dictionary);       
        },
        
        setEmail(){
            if(!this.isUpdate){
                this.formModel.email = this.formModel.username + '@realcount.com';
            }
        },                
        
        async save(isUpdate = false) {                
            this.$validator.validateAll();    
            this.formModel.time = this.$moment().valueOf();
            this.formModel.info = null;            
            if( !this.errors.any() ) { this.loading=true;
                var res = isUpdate ? await model.update(this.formModel): await model.create(this.formModel);                
                if(res.status === 200){  
                    this.$swal({ type: 'success', title: 'Your work has been saved', showConfirmButton: false, timer: 1000});                
                    this.$router.push({path:'/saksi', query:{id:res.data.id}});                    
                } else {
                    var title = res.status ? '#'+res.status + ' Oops...' : 'Oops...';
                    var text  = res.statusText ? res.statusText: 'Something happened in setting up the request that triggered an Error.';                     
                    if(res.data){ if(res.data.message){ text += ' ' + res.data.message; } else {this.validate(res.data);}}                
                    this.$swal({type: 'error', title: title, text: text});                    
                }
                this.loading=false;
            }             
        },
       
        validate(data){
            data.forEach( (item) => {
                this.$validator.errors.add({field : item.field,msg : item.message});
            });
        },        
                
        checking(data){
            if(data.info){
                if(data.info.action === 'synch' && data.info.data){
                    this.validate(data.info.data);
                }
            }            
        },        
                
        clear () {
            this.formModel = {};
            this.$validator.reset();
        },       
        
        setKompetisi(){
            model.kompetisis().then(res=>{              
              this.kompetisis = res;
            });
        },
        
        notSelectKompetisi(){
            let result = [];
            this.kompetisis.forEach(item=>{
                this.forEach()
                result.push()
            });
        },
        
        nameKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.name}});
            return result;
        },
        
        colorKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.color}});
            return result;
        },
        
        tingkatKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.tingkat}});
            return result;
        },
        
        areaKompetisi(id){
            var result = ''; this.kompetisis.forEach(item=>{if(id === item.id){result = item.area_id;}});
            return result;
        },
        
        customFilter (item, queryText, itemText) {
          const textOne = item.name.toLowerCase()
          //const textTwo = item.abbr.toLowerCase()
          const searchText = queryText.toLowerCase()
          return textOne.indexOf(searchText) > -1; 
        }, 
        
        setTingkats(){
          model.childTingkats().then(res =>{
            this.tingkats = res.data;             
            this.tingkats.forEach((tingkat)=>{
              if(this.tingkatDef > tingkat.id){
                this.tingkatDef = tingkat.id;
                this.byrole(this.tingkats);
              }
            });
          });
        },
        
        setRoles(){
          model.childRoles().then(res =>{
            this.roles = res.data;                               
          });
        },
        
        byrole(tingkats){
          let result = [];
          let role = {sys_admin:[0,1,2,3,4,5], dpp:[0,1,2,3,4,5],dpw:[1,2,3,4,5],dpd:[2,3,4,5],dpc:[3,4,5],korsak:[4,5], saksi : [5] };
          tingkats.forEach(item=>{
            if(role[this.formModel.role] && role[this.formModel.role].includes(item.id)){
              result.push(item);
              this.tingkatDef = role[this.formModel.role][0];
            }
          });
          return result;
        },

        nameTingkat(id){
          var result = '';
          this.tingkats.forEach(item=>{if(id === item.id){result = item.name}});
          return result;
        },    
        
        addDtl(newVal){
          this.newDtl({kompetisi_id : newVal, id:null, tingkat:this.tingkatKompetisi(newVal), 
              area:null, areaName:null,
              area_id:this.areaKompetisi(newVal)}, this.idx); 
        },
        
        newDtl(d = null, i = null){
          this.notMagic();               

          this.formModel.userAreas.push({        
            id : d ? d.id : null,            
            kompetisi_id : d ? d.kompetisi_id :null,            
            tingkat : d ? d.tingkat : this.tingkatDef,
            area_id : d ? d.area_id :null,
            magic : true,        
          });      
          
          if(d && !this.panelId.includes(d.kompetisi_id)){
            this.panel.push(true);
            this.panelId.push(d.kompetisi_id);
          }
          
          this.detail.push({
            areas:[],
            areaSearch:null,
            areaLoading:false,        
          });      

          if(d && d.area_id){        
            this.setTabular(d.area_id, i);        
          }
          
          this.$watch(['detail', i, 'areaSearch'].join('.'), (search) => {
            let prop = this.formModel.userAreas[i];
            if(search && prop.tingkat && this.detail[i]){
              this.detail[i].areaLoading = true; var parent_id = prop.tingkat === (this.formModel.tingkat+1)? this.formModel.area_id : null;            
              model.areas({'AreaSearch[name]':search,tingkat :prop.tingkat,'AreaSearch[parent_id]':parent_id}).then(res=>{                             
                if(this.detail[i]){
                  this.detail[i].areas = res;              
                  this.detail[i].areaLoading = false;
                }
              });
            }
          }); 
          this.idx++;
        },

        setTabular(area_id, i){      
          let prop = this.formModel.userAreas[i];

          prop.area = null;   
          if(area_id){
            this.detail[i].areaLoading = true; 
            model.areas({tingkat:prop.tingkat,'AreaSearch[id]':prop.area_id}).then(res=>{
              this.detail[i].areas = res;              
              res.forEach((item)=>{
                prop.area = item.name;
                prop.areaName = item.name;                
                prop.area_id = item.id;
              });
              this.detail[i].areaLoading = false;
            });      
          }
        },

        delDtl(props){            
          let index = this.getIndex(this.formModel.userAreas, props.item);                 
          this.formModel.userAreas.splice(index, 1);   
          this.detail.splice(index, 1);   
        }, 

        isMagic(props){     
          let index = this.getIndex(this.formModel.userAreas, props.item);
          props.item.magic = true;
          this.notMagic(index);            
        },

        notMagic(exc = null){
          this.formModel.userAreas.forEach((item, index)=>{
            if(exc !== index){
              this.formModel.userAreas[index].magic = false;
            }
          });               
        },
        
        getIndex(arr, item){
            return arr.findIndex(function(i){return i == item;}); 
        }
    }
}
</script>
